(function() {
  if (window.__thresholdUpsellBound) return;
  window.__thresholdUpsellBound = true;

  var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';

  function esc(s) {
    var d = document.createElement('div');
    d.textContent = s;
    return d.innerHTML;
  }

  function initUpsell() {
    var container = document.querySelector('[data-delivery-progress]');
    if (!container) return;

    if (container.querySelector('.cart-delivery-progress__upsell-add')) return;

    var handle = container.dataset.upsellHandle;
    var isQualified = container.dataset.isQualified === 'true';
    var remainingCents = parseInt(container.dataset.remainingCents, 10);
    var cartProductIds = (container.dataset.cartProductIds || '').split(',').filter(Boolean);

    if (!handle || isQualified) return;

    fetch(root + 'products/' + handle + '.js')
      .then(function(r) { return r.json(); })
      .then(function(product) {
        if (!product || !product.available) return;

        var variant = null;
        for (var i = 0; i < product.variants.length; i++) {
          if (product.variants[i].available) {
            variant = product.variants[i];
            break;
          }
        }
        if (!variant) return;

        var pid = String(product.id);
        for (var j = 0; j < cartProductIds.length; j++) {
          if (cartProductIds[j] === pid) return;
        }

        if (variant.price < remainingCents) return;
        var pricePounds = (variant.price / 100).toFixed(2);

        var imgHtml = '';
        if (product.featured_image) {
          var src = product.featured_image.replace(/\.([a-z]+)(\?|$)/, '_96x.$1$2');
          imgHtml = '<img src="' + src + '" width="48" height="48" loading="lazy" alt="' + esc(product.title) + '">';
        }

        var c = document.querySelector('[data-delivery-progress]');
        if (!c || c.querySelector('.cart-delivery-progress__upsell-add')) return;

        var html =
          '<div class="cart-delivery-progress__upsell">' +
            '<a href="/products/' + handle + '" class="cart-delivery-progress__upsell-image" tabindex="-1" aria-hidden="true">' + imgHtml + '</a>' +
            '<div class="cart-delivery-progress__upsell-details">' +
              '<a href="/products/' + handle + '" class="cart-delivery-progress__upsell-title">' + esc(product.title) + '</a>' +
              '<span class="cart-delivery-progress__upsell-meta">&pound;' + pricePounds + ' &middot; unlocks free delivery</span>' +
            '</div>' +
            '<button type="button" class="cart-delivery-progress__upsell-add" data-variant-id="' + variant.id + '" aria-label="Add ' + esc(product.title) + ' to cart">Add</button>' +
          '</div>';

        c.classList.add('cart-delivery-progress--has-upsell');
        c.insertAdjacentHTML('beforeend', html);
      })
      .catch(function(err) {
        console.error('[threshold-upsell]', err);
      });
  }

  document.addEventListener('click', function(e) {
    var btn = e.target.closest('.cart-delivery-progress__upsell-add');
    if (!btn) return;

    var variantId = btn.dataset.variantId;
    if (!variantId || btn.disabled) return;

    btn.disabled = true;
    btn.textContent = 'Adding…';

    fetch(root + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({
        items: [{ id: parseInt(variantId, 10), quantity: 1 }]
      })
    })
    .then(function(r) { return r.json(); })
    .then(function(data) {
      if (data.status) throw new Error(data.description || 'Could not add item');

      btn.textContent = 'Added';

      fetch(root + 'cart.js')
        .then(function(r) { return r.json(); })
        .then(function(cart) {
          var s = document.createElement('script');
          s.type = 'module';
          s.textContent =
            'import{CartLinesUpdateEvent}from"@shopify/events";' +
            'var d=CartLinesUpdateEvent.createPromise();' +
            'document.dispatchEvent(new CartLinesUpdateEvent({' +
              'action:"add",' +
              'lines:[{merchandiseId:' + parseInt(variantId, 10) + ',quantity:1}],' +
              'promise:d.promise' +
            '}));' +
            'd.resolve({cart:CartLinesUpdateEvent.createCartFromAjaxResponse(' +
              JSON.stringify(cart) +
            '),detail:{}});';
          document.head.appendChild(s);
          s.remove();
        });
    })
    .catch(function(err) {
      console.error('[threshold-upsell]', err);
      btn.disabled = false;
      btn.textContent = 'Add';
    });
  });

  initUpsell();

  var timer;
  new MutationObserver(function(mutations) {
    for (var i = 0; i < mutations.length; i++) {
      if (mutations[i].addedNodes.length) {
        clearTimeout(timer);
        timer = setTimeout(initUpsell, 50);
        return;
      }
    }
  }).observe(document.body, { childList: true, subtree: true });
})();
